import React from 'react';

import classes from './TabsSecondary.module.scss';

const TabsSecondary = ({ children, onClick, Icon, selected }) => {
  const classesContent = [classes.tab];

  selected && classesContent.push(classes.focus);
  return (
    <button onClick={onClick} className={`semibold-16  pointer ${classesContent.join(' ')} `}>
      {Icon && <Icon className={classes.icon} />}
      {children}
    </button>
  );
};

export default TabsSecondary;
